import { render } from "./TechnicalModelModify.vue?vue&type=template&id=f1a9795a&scoped=true"
import script from "./TechnicalModelModify.vue?vue&type=script&lang=js"
export * from "./TechnicalModelModify.vue?vue&type=script&lang=js"

import "./TechnicalModelModify.vue?vue&type=style&index=0&id=f1a9795a&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a9795a"]])

export default __exports__